import React from 'react';
import { AtdwSearchOrMap } from './view/atdwSearchOrMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwSearchOrMap', 
  itemElt: (item, cmsOption) => <AtdwSearchOrMap item={item} cmsOption={cmsOption} />
}